import React, { useState } from 'react';
import { accelerateData } from '../data/mockData';

const AccelerateSection = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <section className="bg-[#EEF2E1] py-16 lg:py-24">
      <div className="max-w-[1121px] mx-auto px-6 lg:px-10">
        {/* Title: 64px, weight 300 */}
        <h2 className="text-[#0A3900] text-[36px] lg:text-[64px] font-light leading-[1] tracking-[-0.011em] mb-2">
          {accelerateData.label}
        </h2>
        {/* Subtitle: 16px, weight 400 */}
        <p className="text-[#082900] text-[14px] lg:text-[16px] font-normal leading-[1.2] mb-10 lg:mb-14 max-w-xl">
          {accelerateData.subtitle}
        </p>

        {/* 3-column grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {accelerateData.tabs.map((tab, i) => (
            <div
              key={i}
              className="group cursor-pointer"
              onClick={() => setActiveTab(i)}
            >
              <div className="rounded-2xl overflow-hidden aspect-[4/5] mb-5">
                <img
                  src={tab.image}
                  alt={tab.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              {/* Card title: 24px, weight 400 */}
              <h3 className="text-[#0A3900] text-[20px] lg:text-[24px] font-normal leading-[1] mb-3">
                {tab.title}
              </h3>
              {/* Card description: 16px, weight 400 */}
              <p className="text-[#082900] text-[14px] lg:text-[16px] font-normal leading-[1.5]">
                {tab.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AccelerateSection;
